import React from 'react';
import { useData } from '../context/DataContext';
import NestedCategoryFlyout from './NestedCategoryFlyout';
import './BrowseDealsMenu.css';
import './NestedCategoryFlyout.css';

const AllCategoriesPanel = ({ onClose }) => {
  const { categoriesForNav, categoryMenuTreeByCategory } = useData();

  const categories = (categoriesForNav || []).map((cat) => ({
    id: cat._id || cat.id,
    name: cat.name,
    slug: cat.slug,
  }));

  return (
    <NestedCategoryFlyout
      categories={categories}
      menuTreeByCategory={categoryMenuTreeByCategory}
      onClose={onClose}
      anchor="left"
      className="browse-categories-nested-flyout"
    />
  );
};

export default AllCategoriesPanel;
